module.exports = __webpack_public_path__ + "a2314fc9/img/product-icon-grey.b248963c.svg";